import {Component, Inject} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";

import {IrbCommonModule} from "@irb-common/irb-common.module";
import {MatCard, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {ModelMarketCenterService} from "@irb/irb-models/model-market-center/model-market-center.service";
import {IrbAppEvents} from "@irb/app.events";
import {IModelImportSave} from "@irb/irb-models/models-new/models.service";
import {AppService} from "@irb/app.service";
import {IAlertDialogData} from "@irb/app.model";

@Component({
  selector: 'irb-import-mmc-models-dialog-finish',
  standalone: true,
  imports: [
    MatDialogModule,
    IrbCommonModule,
    MatButton,
    MatCard,
    MatCardTitle
],
  templateUrl: './import-mmc-models-dialog-finish.component.html',
  styleUrl: './import-mmc-models-dialog-finish.component.scss'
})
export class ImportMmcModelsDialogFinishComponent {

  gridUnrecognized: any;
  gridOptionsUnrecognized: any;
  frameworkComponents: any;
  gridContains: any;
  gridOptionsContains: any;
  gridOptionsFinish: any;
  gridFinish: any;
  dialogTitle = 'Unrecognized Securities in Your File';
  showUnrecognizedGrid = true;
  showContainsGrid = false;
  showFinish = false;
  isUiTest = false;
  progressTimer: any;
  showInformaErrorMessages = false;
  gridInformaErrors: any;
  gridOptionsInformaErrors: any;
  informaErrorsData: any[] = [];

  constructor(public dialogRef: MatDialogRef<ImportMmcModelsDialogFinishComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private mmcService: ModelMarketCenterService,
              public as: AppService) {

    this.defineShowBlock(true);

    this.gridOptionsUnrecognized = {
      columnDefs: this.getColumnDefsUnrecognized(),
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };

    this.gridOptionsContains = {
      columnDefs: this.getColumnDefsContains(),
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };

    this.gridOptionsFinish = {
      columnDefs: this.getColumnDefsFinish(),
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>"
    };

    this.gridOptionsInformaErrors = {
      columnDefs: this.getColumnDefsInformaErrors(),
      autoGroupColumnDef: {headerName: 'Informa PSN ID'},
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>"
    };

    this.frameworkComponents = {};
  }


  close() {
    this.dialogRef.close();
  }

  getColumnDefsUnrecognized(): any[] {
    return [{
      headerName: 'Symbol/Cusip',
      field: 'securitySymbol'
    }];
  }

  onGridReadyUnrecognized(params: any) {
    this.gridUnrecognized = params;
    this.gridUnrecognized.api.setGridOption('domLayout', 'normal');
  }

  continueAction() {
    if (this.showUnrecognizedGrid)
      this.showUnrecognizedGrid = false;
    if (this.showContainsGrid)
      this.showFinish = true;
    this.defineShowBlock();
  }

  onGridReadyContains(params: any) {
    this.gridContains = params;
    this.gridContains.api.setGridOption('domLayout', 'normal');
  }

  getColumnDefsContains() {
    return [
      {
        headerName: "Symb/Csp",
        field: "securitySymbol",
        maxWidth: 100,
        flex: 1
      },
      {
        headerName: "Description",
        field: "securityDescription",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          }
        },
        flex: 1
      },
      {
        headerName: "Type",
        field: "securityType",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        flex: 1
      },
      {
        headerName: "CustCat",
        field: "customCategoryName",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        flex: 1
      }
    ];
  }

  onGridReadyFinish(params: any) {
    this.gridFinish = params;
    this.gridFinish.api.setGridOption('domLayout', 'normal');
  }

  getColumnDefsFinish() {
    return [{
      headerName: 'Name',
      field: 'modelName',
      cellRenderer: 'cellRendererFormatter',
      cellRendererParams: {
        text: (params: any) => {
          return (params.value != null && params.value.length > 0);
        }
      },
      maxWidth: 200,
      width: 200

    },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: {
          text: (params: any) => {
            return (params.value != null && params.value.length > 0);
          }
        },
        width: 235
      },
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: {
          text: (params: any) => {
            return (params.value != null && params.value.length > 0);
          }
        },
        maxWidth: 170,
        width: 170
      }];
  }

  defineShowBlock(init = false) {
    if (init) {
      const hasInformaErrors = this.data.informaErrorMessages && Object.keys(this.data.informaErrorMessages).length > 0;
      if (hasInformaErrors) {
        this.showInformaErrorMessages = true;
        this.showUnrecognizedGrid = false;
        this.showContainsGrid = false;
        this.showFinish = false;
        this.dialogTitle = 'Data Errors';
        this.prepareInformaErrorsData();
        return;
      }
    }

    if (this.data.unrecognized && this.data.unrecognized.Models && this.data.unrecognized.Models.length > 0 && this.showUnrecognizedGrid) {
      this.showUnrecognizedGrid = true;
      this.showContainsGrid = false;
      this.showFinish = false;
      this.dialogTitle = 'Unrecognized Securities in Your File';
    } else if (this.data.noninventoried && this.data.noninventoried.Models && this.data.noninventoried.Models.length > 0 && !this.showFinish) {
      this.showUnrecognizedGrid = false;
      this.showContainsGrid = true;
      this.showFinish = false;
      this.dialogTitle = 'Your File Contains Securities not in iRebal';
    } else {
      this.showUnrecognizedGrid = false;
      this.showContainsGrid = false;
      this.showFinish = true;
      this.dialogTitle = 'Models Ready to Import';
    }
  }

  completeImport() {
    if (this.progressTimer) clearTimeout(this.progressTimer);
    const r: any = {};
    r.validRows = this.data.validRows;

    if (this.data.noninventoried && this.data.noninventoried.Securities && this.data.securitiesToAdd.length > 0) {
      r.securitiesToAdd = this.data.noninventoried.Securities;
    }
    this.mmcService.importMMCModelsAsync(r).subscribe((response: any) => {
      if (response.responseStatus === "SUCCESS") {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        this.checkIntervalStart(response.responseUtilityMap.statusId);
        this.close();
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        this.close();
        let errorMsg = 'An error occurred processing your request.';
        if (response.errors && response.errors.length > 0)
          errorMsg = response.errors[0].message || errorMsg;
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'Import MMC Models',
          detail: errorMsg
        });
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.close();
    });
  }

  checkIntervalStart(_statusId: any) {
    this.mmcService.importMMCModelsAsyncStatus(_statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const response = statusResponse?.responseUtilityMap;
        const reqStatus = response?.requestStatus?.trim().toUpperCase();
        if (reqStatus === 'FAILED') {
          this.actionStatusCheckFailed();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          let timeout = this.isUiTest ? 0 : 1500;
          this.progressTimer = setTimeout(() => {
            this.checkIntervalStart(_statusId);
          }, timeout);
        }
        if (reqStatus === 'COMPLETED') {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          if (this.progressTimer) clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'success',
            summary: 'Import Security Models',
            detail: statusResponse?.responseData?.successCount + " MMC model(s) were sucessfully imported."
          });
          this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
        }
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        if (this.progressTimer) clearTimeout(this.progressTimer);
      }
  },() => {
        if (this.progressTimer) clearTimeout(this.progressTimer);
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      });
  }

  actionStatusCheckFailed() {
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    if (this.progressTimer) clearTimeout(this.progressTimer);
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    } as IAlertDialogData);
  }

  continueActionAfterInformaErrors() {
    this.showUnrecognizedGrid = true;
    this.showInformaErrorMessages = false;
    this.defineShowBlock();
  }

  copyToClipboard() {
    if (this.gridInformaErrors && this.gridInformaErrors.api) {
      this.gridInformaErrors.api.forEachNode((node: any) => {
        node.setSelected(true);
      });
      this.gridInformaErrors.api.copySelectedRowsToClipboard();
    }
  }

  getColumnDefsInformaErrors() {
    const isRowGroup = this.informaErrorsData.length > 1;
    return [
      { field: "psnid", rowGroup: isRowGroup, hide: isRowGroup, flex: 1, width: 100, maxWidth: 100 },
      { field: "entity", flex: 2,
        valueGetter: (params: any) => {
          let retVal: string = params.node.level === 0 && isRowGroup ? 'multiple' : params.node.data.entity;
          if (params.node.level === 0 && params.node.expanded)
            retVal = '';
          return retVal;
        },
        cellStyle: (params: any) => {
          if (params.node.level === 0  && isRowGroup) {
            return { 'font-style': 'italic' }
          } else {
            return null;
          }
        }
      },
      { field: "error", headerName: 'Error Condition', flex: 2,
        valueGetter: (params: any) => {
          let retVal: string = params.node.level === 0 && isRowGroup ? 'multiple' : params.node.data.error;
          if (params.node.level === 0 && params.node.expanded)
            retVal = '';
          return retVal;
        },
        cellStyle: (params: any) => {
          if (params.node.level === 0 && isRowGroup) {
            return { 'font-style': 'italic' }
          } else {
            return null;
          }
        }
      }
    ];
  }

  onGridReadyInformaErrors(params: any) {
    this.gridInformaErrors = params;
    this.gridInformaErrors.api.setGridOption('domLayout', 'normal');
  }

  prepareInformaErrorsData() {
    let record, errors;
    for (const psnId in this.data.informaErrorMessages) {
        if (this.data.informaErrorMessages.hasOwnProperty(psnId)) {
            errors = this.data.informaErrorMessages[psnId];
            errors.forEach((err: string) => {
              const arrArr = err.split(" : ");
              record = {
                psnid: psnId,
                entity: arrArr[0],
                error: arrArr[1]
              }
              this.informaErrorsData.push(record);
            });
        }
    }

  }
}
